import { render, staticRenderFns } from "./indexAboutSwiper.vue?vue&type=template&id=5a97589e&scoped=true"
import script from "./indexAboutSwiper.vue?vue&type=script&lang=js"
export * from "./indexAboutSwiper.vue?vue&type=script&lang=js"
import style1 from "./indexAboutSwiper.vue?vue&type=style&index=1&id=5a97589e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97589e",
  null
  
)

export default component.exports